/*
 * 请求正常响应码
 * @author miqiang
 * @date 2019-11-01
 */
export class NormalCode {

    /**
     * 请求正常处理的返回码
     */
    public static NORMAL_CODE = 2000;

    /**
     * 请求正常处理,无返回值
     */
    public static NORMAL_REQUEST_NO_VALUE = 2001;

    /**
     * 值已经存在
     */
    public static NORMAL_VALUE_EXIT = 2002;

    /**
     * 拒绝操作
     */
    public static NORMAL_REJECT = 2003;

    /**
     * 请求换课正常处理的返回码
     */
    public static NORMAL_HKCODE = 2004;

    /**
     * 请求正常，需要用户选择处理
     */
    public static NORMAL_NEED_TO_DEAL = 2005;

    /**
     * 请求正常，带有下一页面的跳转路径。返回参数：path
     */
    public static NORMAL_PATH = 2006;

}